import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchAllLocation } from "./locationAPI";
import { unwrapApiResponse } from "../../util/util";
import { locationUtils } from "../../util/LocationUtils";

const initialState = {
  allLocations: [],
  selectedAddress: {},
  status: "idle",
  newAddressStatus: "idle",
  initialLocation: locationUtils.getSelectedLocation() || {},
  locationsError: ""
};

export const getLocations = createAsyncThunk(
  "locations/fetchLocations",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchAllLocation();
      return unwrapApiResponse(response, rejectWithValue);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch locations");
    }
  }
);

export const locationSlice = createSlice({
  name: "locations",
  initialState,
  // The `reducers` field lets us define reducers
  // and generate associated actions
  reducers: {
    setSelectedAddress: (state, action) => {
      // state[selectedAddress] = action.payload;
    },
    setInitialAddress: (state, action) => {
      state.initialLocation = action.payload;
      locationUtils.storeTokens(action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLocations.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getLocations.fulfilled, (state, action) => {
        state.status = "succeeded";
        const locationsPayload = action.payload;
        state.allLocations = locationsPayload;
        if (locationsPayload.length === 1) {
          state.initialLocation = locationsPayload[0];
          locationUtils.storeTokens(locationsPayload[0]);
        }
      });
  }
});

export const { setSelectedAddress, setInitialAddress } = locationSlice.actions;
export const allLocations = (state) => state.locations.allLocations;
export const locationsStatus = (state) => state.locations.status;
export const selectedAddress = (state) => state.locations.selectedAddress;
export const newAddressStatus = (state) => state.locations.newAddressStatus;
export const initialLocation = (state) => state.locations.initialLocation;
export const locationsError = (state) => state.locations.locationsError;

export default locationSlice.reducer;
